import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CalendarCheckIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.28 18.54H3.72V5.38H20.28V18.54ZM18.64 16.9V9.86H5.36V16.9H18.64ZM8.58 13.28L9.54 12.34L11.24 14.04L14.34 10.92L15.3 11.88L11.24 15.96L8.58 13.28Z" />
    </SvgIcon>
  );
});
